// Guided US phone input for the public forms (moved here from PartnerSignup,
// 2026-10-14, so every form behaves the same): live-formats to
// "(904) 555-1212", hard-caps at 10 digits so extra typing does nothing, and
// quietly drops a leading country-code 1 from pasted or autofilled values
// ("+1 904..." is how browser autofill writes saved numbers). The server
// validates independently (server/lib/phone.js normalizeUsPhone, exactly 10).
//
// Never put maxLength on an input that uses this: the browser would truncate
// a pasted "+1 (904) 555-1212" before the formatter runs.

const onlyDigits = (v) => String(v || '').replace(/\D/g, '');

/** The 10-digit US number in a value, a leading country-code 1 dropped. */
export const usPhoneDigits = (raw) => {
  let d = onlyDigits(raw);
  if (d.startsWith('1') && d.length > 10) d = d.slice(1);
  return d.slice(0, 10);
};

export const formatUsPhone = (raw) => {
  const d = usPhoneDigits(raw);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

export const isUsPhone = (raw) => usPhoneDigits(raw).length === 10;
